import {SectionItem} from 'common/components/items-menu/types';

import {ActionType, EventItem, ItemTriggerCustomEventModal, MenuType, ModalType, StageTagsListMenuItem} from './types';

export const ANY_EVENT: SectionItem<EventItem> = {
  icon: `event`,
  label: `Any event`,
  value: {
    value: `$mp_anything_event`,
    label: `Any event`,
  },
};

export const SESSION_START_EVENT: SectionItem<EventItem> = {
  icon: `stop-watch`,
  label: `Session Start`,
  value: {
    value: `$session_start`,
    label: `Session Start`,
  },
};

export const SESSION_END_EVENT: SectionItem<EventItem> = {
  icon: `stop-watch`,
  label: `Session End`,
  value: {
    value: `$session_end`,
    label: `Session End`,
  },
};

export const CREATE_CUSTOM_EVENT: SectionItem<ItemTriggerCustomEventModal> = {
  isControlItem: true,
  icon: `compose`,
  label: `Create Custom Event...`,
  value: {
    action: ActionType.TriggerModal,
    modalType: ModalType.CreateCustomEvent,
    label: `Create Custom Event...`,
  },
};

export const TAGS_MENU: SectionItem<StageTagsListMenuItem> = {
  label: `Tags`,
  value: {
    action: ActionType.StageMenu,
    menuType: MenuType.Tags,
  },
  hasCaret: true,
};
